<div class="row" style="height: 100%; display: flex; justify-content: center; align-items: center;">
  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="toggleBadgeNotifications()" class="centered-button" style="font-size: 48px; padding: 12px;">
    <img [src]="_appsService.companyColorCode || _appsService.projectColorCode ? 'assets/icons/notifications_white.png' : 'assets/icons/bell.png'" alt="bell" class="centered-image" style="width: 45px; height: 45px;">
    <mat-icon [matBadge]="notificationBadge" matBadgeColor="warn" [matBadgeHidden]="notificationBadge == 0" color="accent" #notifications id="notifications"></mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu" class="menu notification-overlay" style="background-color: #FFFFFF !important; min-width:500px;">
  <div *ngIf="notifactionList.length > 0 || tspVrpModel != null || excelCalculationModel; else noNotifications">
    <div *ngFor="let notif of notifactionList.slice(0,3); let i = index;">
      <!--<div *ngIf="notif.notificationTypeId == notificationEnum.ExcelImportType">
      <menu mat-menu-item [style.background-color]="!notif.isSee ? '#e9f0f3' : 'white'" matTooltip="{{notif.title}}" style="height:50px;margin:0!important" (click)="getRouter(notif)">
        <mat-icon color="primary">campaign</mat-icon>
        {{notif.title}}
      </menu>
      <menu mat-menu-item *ngIf="notif.body?.length" matTooltip="{{notif.body}}" (click)="getRouter(notif)">
        {{notif.body}}
      </menu>
    </div>
    <div *ngIf="notif.notificationTypeId != notificationEnum.ExcelImportType">
      <menu mat-menu-item [style.background-color]="!notif.isSee ? '#e9f0f3' : 'white'" matTooltip="{{notif.title}}" style="height:50px;margin:0!important" (click)="getRouter(notif)">
        <mat-icon color="primary">campaign</mat-icon>
        {{notif.title}}
      </menu>
      <menu mat-menu-item *ngIf="notif.body?.length" (click)="getRouter(notif)" matTooltip="{{notif.body}}">
        {{notif.body}}
      </menu>
      <menu mat-menu-item *ngIf="notif.body?.length">
        {{'calculationTaskPercent' | translate}}:  %{{notif.taskPercent}}
      </menu>
    </div>-->
      <div>
        <!--[style.background-color]="!notif.isSee ? '#e9f0f3' : 'white'"-->
        <menu mat-menu-item matTooltip="{{notif.title}}" style="height:80px;margin:0!important; width:100%; min-width:360px; " (click)="getRouter(notif)" [ngClass]="this._appsService.classes">
          <!--<mat-icon color="primary">campaign</mat-icon>-->
          <div style="width:15%; height:100px; display:flex; justify-content:center; align-items:center;">
            <img style="width:5px; height:55px; position:absolute; left:0;" src="assets/icons/notifications/success-notif-side.png" />
            <img style="width:50px;" src="assets/icons/notifications/successfull-notif.png" />
          </div>
          <div style=" width: 85%; display: flex; justify-content: space-between; padding: 0 5px;">
            <div style="width: 100%; justify-content: center; width: 80%; display: flex; flex-direction: column;">
              <div style="color: #777777; font-size: 12px; font-weight: 500 " [ngClass]="this._appsService.classes">
                {{notif.title}}
              </div>
              <div style="color: #777777; font-weight: 300;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1;
            max-width:350px;
            max-height: 65px;"
                   [ngClass]="this._appsService.classes">
                {{notif.body}}
              </div>
            </div>
            <div style="display: flex; align-items: center; font-weight: 300; font-size: 11px; width: 30%; justify-content: center;
            text-align: center; white-space: normal; word-wrap: break-word; line-height: 1.2;"
                 [ngClass]="_appsService.classes">
              {{ calculateDaysPassed(notif.creationTime) }}
            </div>
          </div>
        </menu>

      </div>
    </div>
    <hr *ngIf="tspVrpModel !=null || excelCalculationModel !=null"
        style="border-color: #F3F3F3; margin: 0 !important; height: 1px !important; border-width: thin;" />

    <div *ngIf="tspVrpModel !=null || excelCalculationModel !=null">
      <div class="header-text">Devam Eden İşlemler</div>

      <div *ngIf="tspVrpModel" class="calculation-container">
        <div class="icon-container">
          <img class="side-icon" src="assets/icons/notifications/success-notif-side.png" />
          <img class="main-icon" src="assets/icons/notifications/successfull-notif.png" />
        </div>
        <div class="text" [ngClass]="_appsService.classes">{{ localizeCalculationType(tspVrpModel.calculationTypeId) }}</div>
        <div class="text" [ngClass]="_appsService.classes">{{ tspVrpModel.calculationStartDate }}</div>
        <div class="text" [ngClass]="_appsService.classes">{{ tspVrpModel.calculationState | localize }}</div>
        <button mat-button
                class="cancel-button"
                [ngClass]="_appsService.classes"
                (click)="calculationCancel(tspVrpModel.id)">
          {{ 'calculationCancel' | localize }}
        </button>
      </div>

      <div *ngIf="excelCalculationModel !=null" class="calculation-container">
        <div class="icon-container">
          <img class="side-icon" src="assets/icons/notifications/success-notif-side.png" />
          <img class="main-icon" src="assets/icons/notifications/successfull-notif.png" />
        </div>
        <div class="text" [ngClass]="_appsService.classes">{{ excelCalculationModel.title }}</div>
        <div class="text" [ngClass]="_appsService.classes">{{ excelCalculationModel.calculationStartDate }}</div>
        <button mat-button
                class="cancel-button"
                [ngClass]="_appsService.classes"
                (click)="calculationExcelCancel(excelCalculationModel.id)">
          {{ 'calculationCancel' | localize }}
        </button>
      </div>
    </div>

    <hr style=" border-color: #F3F3F3; margin: 0 !important; height: 1px !important; border-width: thin;" />
    <menu mat-menu-item
          style="background-color:#FFFFFF; min-height:40px !important; transition: background-color 0.3s, color 0.3s;"
          (click)="showAllNotifications()"
          (mouseenter)="onMouseEnter($event)"
          (mouseleave)="onMouseLeave($event)">

      <div style="height: 20px; display: flex; justify-content: center; align-items: center; font-size:12.5px;" [ngClass]="this._appsService.classes">
        {{'clickForAllNotification' | localize}}
      </div>
    </menu>
  </div>
  <ng-template #noNotifications>
    <div style="color: #777777; font-size: 12px; font-weight: 500; padding: 20px; text-align: center; font-size:12.5px;" [ngClass]="this._appsService.classes">
      {{'thereIsNoNotification' | localize}}
    </div>
  </ng-template>
</mat-menu>
